import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import SajuContentSlider from "./SajuContentSlider";
import { getAdBanners } from "../data/adBannerData";

const SajuContents = () => {
  // 중앙화된 데이터 사용
  const slideOptions = getAdBanners();
  const isSingleSlide = slideOptions.length <= 1;

  var settings = {
    dots: false,
    arrow: false,
    autoplay: !isSingleSlide,
    autoplaySpeed: 3000,
    cssEase: "linear",
    infinite: !isSingleSlide,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <div className="product-slider">
      <div className="slider-container">
        <Slider {...settings}>
          {slideOptions.map((slide, index) => (
            <SajuContentSlider key={index} {...slide} />
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default SajuContents;
